// Generated during production source sync. Kept empty in the repository so CI/typecheck works without network access.
export type GeneratedReview = { name: string; text: string };
export const generatedReviews: Record<string, GeneratedReview[]> = {};
